module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-pto-e44887ff3ce58e0f5c59b810f7b6c839.svg";